var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiving(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#1E81F7",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "40px",
    height: "40px",
    viewBox: "0 0 889.301 889.3",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M800.801,17.701h-28.102c-19.299,0-35,15.7-35,35v167.5c32.5,10.9,56,41.6,56,77.7v149c0,10-0.699,19.899-2,29.699 c-2.6,18.801-7.6,37-15,54.601c-9.5,22.5-22.6,42.899-38.898,61c-2.4,2.7-4.9,5.3-7.5,7.899c-8.9,8.9-18.5,17-28.701,24.101 c5.1,3,11.1,4.7,17.4,4.7h18.4c-5.1,80.8-72.6,145-154.701,144.8c-81.6-0.2-148-64.5-153.699-144.8h52.699 c-7.398-6.2-14.199-13.101-20.299-20.5L428.6,567.8l-35.1-43.3c-4.7-5.8-10.7-6.6-13.9-6.6s-9.2,0.899-13.9,6.6l-35.1,43.3 l-32.8,40.5c-6.101,7.5-12.9,14.4-20.3,20.5H330.9c2.8,62.7,28.2,122.7,72.5,167.601c47.901,48.5,111.799,75.199,179.901,75.199 c68.1,0,132-26.699,179.898-75.199c44.301-44.9,69.701-104.9,72.5-167.601h19c19.102,0,34.602-15.5,34.602-34.6V511.1 c0-19.1-15.5-34.6-34.602-34.6H836v-423.8C835.801,33.3,820.199,17.701,800.801,17.701z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.2,176.201l-20,39.6H576l-20-39.6c-6-11.8-18-19.2-31.199-19.2H234.5C221.3,157,209.2,164.5,203.2,176.201z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,297.8v149c0,100.5,81.5,182,182,182l0,0c34.3,0,66.8-15.399,88.5-41.899c0.1-0.101,0.199-0.301,0.3-0.4l59.7-73.7 l8.199-10.1c10.5-13,25.7-19.5,40.801-19.5c15.199,0,30.3,6.5,40.8,19.5l8.2,10.1l59.699,73.7c0.102,0.1,0.201,0.3,0.301,0.4 c21.699,26.5,54.199,41.899,88.5,41.899l0,0c40.1,0,77.199-13,107.301-35c22.1-16.1,40.398-37.1,53.299-61.399 c9.201-17.2,15.6-36,18.9-55.801c1.6-9.699,2.4-19.6,2.4-29.699v-149c0-16.5-8.5-31.1-21.301-39.6c-7.5-4.9-16.4-7.8-26-7.8H593.5 H165.7H47.4C21.2,250.5,0,271.701,0,297.8z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiving);
export default __webpack_public_path__ + "static/media/diving.4fdd8626f048f44a7a6e8b1588dacde4.svg";
export { ForwardRef as ReactComponent };